import PropTypes from 'prop-types';
import React from 'react';

//Components
import SummaryHeader from './summaryHeader.jsx';
import SummaryBody from './summaryBody.jsx';

const SummaryReport = (props) => {
  const {icon, description, title, tooltip, buttons, POS, truBlue} = props;

  return (
    <div className='report-block-container'>
      <SummaryHeader title={title} icon={icon} description={description} tooltip={tooltip} link={buttons[0] ? buttons[0].link : ''}
      />
      <SummaryBody POS={POS} buttons={buttons} truBlue={truBlue}/>
    </div>
  );

};

SummaryReport.propTypes = {
  icon: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  description: PropTypes.string.isRequired,
  title: PropTypes.any.isRequired,
  buttons: PropTypes.any,
  POS: PropTypes.bool.isRequired,
  truBlue: PropTypes.bool,
};

export default SummaryReport;
